(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("BaseComponentsShowCase", BaseComponentsShowCase);

  function BaseComponentsShowCase() {
  }
})();


